import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNeutral = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .8,
			y: 1.05,
			width: 18.4,
			height: 18.4,
			rx: 9.2,
			fill: ""
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .8,
			y: 1.05,
			width: 18.4,
			height: 18.4,
			rx: 9.2,
			stroke: "#888EAA",
			strokeWidth: 1.6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 10.25H14",
			stroke: "#888EAA",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNeutral;
